import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';


@Component({
  selector: 'formly-field-tabs',
  template: `
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [(selectedIndex)]="selectedIndex">
      <mat-tab 
        *ngFor="let tab of field.fieldGroup; let i = index; let last = last"
        [label]="tab.props.label" [attr.data-test] = "'tab-'+ i"
      >
        <formly-field [field]="tab"></formly-field>

        <div class="d-flex justify-content-center align-items-center buttons">
            <button *ngIf="(field.fieldGroup?.length - 1) !== selectedIndex" mat-raised-button [ngClass]="field.props.isPublicForm ? 'btn btn-primary' : 'context-button'" mat-raised-button color="primary"
              type="button" (click)="moveToNextTab()">
              {{ 'BUTTON.NEXT' | translate }}
              <mat-icon style="width: 16px;">chevron_right</mat-icon>
            </button>
            <button *ngIf="(field.fieldGroup?.length - 1) === selectedIndex" mat-raised-button [ngClass]="field.props.isPublicForm ? 'btn btn-primary' : 'context-button'" [disabled]="field.props.submitting"
              mat-raised-button color="primary" type="submit">{{ 'BUTTON.SUBMIT' | translate }}</button>
            <button *ngIf="field.props.isPublicForm" mat-button class="btn" [disabled]="field.props.submitting"
              type="button" (click)="options.resetModel()">{{ 'BUTTON.CLEAR' | translate }}</button>
        </div>
      </mat-tab>
    </mat-tab-group>
  `,
  styleUrls: ['./tabs-type.component.scss'],
})

export class FormlyFieldTabs extends FieldType {
  
  selectedIndex = 0;
  
  moveToNextTab(): void {
    this.selectedIndex = this.selectedIndex + 1;
  }

}